export default {
  ESAD_DEFAULT: 1000
}
